import React from 'react';
import {
  Card, CardBody, CardTitle, Typography
} from '@one-thd/sui-atomic-components';
import { Clock, Heart, Note, Savings } from '@one-thd/sui-icons';

const ListBenefitsDetails = () => {

  const benefits = [{
    icon: <Heart />,
    title: 'Add Items Fast',
    description: 'Select the heart icon to quickly save items as you shop.'
  }, {
    icon: <Clock />,
    title: 'Save Time',
    description: 'Remember exactly what you need and make fewer store runs.'
  }, {
    icon: <Savings />,
    title: 'Save Money',
    description: 'Get notified when an item goes on sale or its price drops.'
  }, {
    icon: <Note />,
    title: 'Plan Projects',
    description: 'Keep track of supplies and stay organized while you work.'
  }];

  return (
    <div
      className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-2 xl:sui-grid-cols-4 sui-gap-3"
      data-component="ListBenefitsDetails"
    >
      {
        benefits.map((benefit, index) => {
          return (
            <Card key={index}>
              {benefit.icon}
              <CardTitle header={benefit.title} />
              <CardBody>
                <Typography>
                  {benefit.description}
                </Typography>
              </CardBody>
            </Card>
          );
        })
      }
    </div>
  );
};

ListBenefitsDetails.displayName = 'ListBenefitsDetails';

export { ListBenefitsDetails };